import team from './team';
import services from './services';
import activities from './activities';
import portfolio from './portfolio';
import destinations from './destinations';
import tours from './tours';
import blogs from './blogs';
import products from './products';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'about us'},
            {id: 2, link: '/Team', title: 'team'},
            {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Gallery", title: "Gallery"  },
            { id: 2, link: "/Pricing", title: "Pricing" },
            {
                id: 3,
                title: "Activity",
                children: [
                    { id: 1, link: "/Activities", title: "Activities" },
                    { id: 2, link: "/Activities/Activity-Single", title: "Activity Single",  state:activities[0] },
                ],
            },
            {
                id: 4,
                title: "Service",
                children: [
                    { id: 1, link: "/Services", title: "Services" },
                    { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
                ],
            },
            {
                id: 5,
                title: "Portfolio",
                children: [
                    { id: 1, link: "/Portfolio", title: "Portfolio" },
                    { id: 2, link: "/Portfolio/Portfolio-Single", title: "Portfolio Single",  state: portfolio[0] },
                ],
            },
            {
                id: 6,
                title: "Information Hub",
                children: [
                    { id: 1, link: "*", title: "Error 404" },
                    { id: 2, link: "/Services-Terms", title: "Terms of Services" },
                    { id: 3, link: "/Privacy-Policy", title: "Privacy Policy" },
                ],
            },
            { id: 7, link: "/Partners", title: "Partners" },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Destination'},
        subLink: [
            { id: 1, link: "/Destinations", title: "Destinations" },
            { id: 2, link: "/Destinations/Destination-Single", title: "Destination Single",  state: destinations[0] },
        ],
    },
    {
        id: 5,
        mainLink : {link: '#', title: 'Tour'},
        subLink: [
            { id: 1, link: "/Tour-Category", title: "Tour Category" },
            { id: 2, link: "/Tour-Offers", title: "Tour Offers" },
            { id: 3, link: "/Tours", title: "Tour Packages" },
            { id: 4, link: "/Tours/Tour-Single", title: "Tour Single",  state: tours[0] },
            { id: 5, link: "/Tour-Booking", title: "Tour Booking" },
        ],
    },
    {
        id: 6,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;